import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';
import {
  FaUser,
  FaEnvelope,
  FaTag,
  FaCommentDots,
  FaPaperPlane,
  FaCheckCircle,
  FaExclamationTriangle,
  FaMapMarkerAlt,
  FaPhone,
  FaLinkedin,
  FaGithub,
} from 'react-icons/fa';
import profile from '../data/profile';
import Reveal from './Reveal';

const Contact = () => {
  const { t, i18n } = useTranslation();
  const country = profile.country[i18n.language] || profile.country.en;
  const formRef = useRef(null);
  const [form, setForm] = useState({
    user_name: '',
    user_email: '',
    user_subject: '',
    user_message: '',
  });
  const [status, setStatus] = useState('idle');

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (status === 'sending') return;
    setStatus('sending');
    emailjs
      .sendForm(
        profile.emailjs.serviceId,
        profile.emailjs.templateId,
        formRef.current,
        profile.emailjs.publicKey
      )
      .then(
        () => {
          setStatus('success');
          setForm({
            user_name: '',
            user_email: '',
            user_subject: '',
            user_message: '',
          });
          setTimeout(() => setStatus('idle'), 6000);
        },
        (err) => {
          console.error('EmailJS error', err);
          setStatus('error');
          setTimeout(() => setStatus('idle'), 6000);
        }
      );
  };

  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-kicker">04 / {t('contact.title')}</span>
          <h2 className="section-title">
            {t('contact.title')}<span className="accent">.</span>
          </h2>
          <p className="section-lead">{t('contact.lead')}</p>
        </Reveal>

        <div className="contact-grid">
          <Reveal delay={50}>
            <form
              ref={formRef}
              onSubmit={submit}
              className="contact-form glass"
              noValidate
            >
              <div className="field-row">
                <label className="field">
                  <span className="field-label">
                    <FaUser /> {t('contact.name')} <em>*</em>
                  </span>
                  <input
                    type="text"
                    name="user_name"
                    value={form.user_name}
                    onChange={onChange}
                    required
                    autoComplete="name"
                  />
                </label>
                <label className="field">
                  <span className="field-label">
                    <FaEnvelope /> {t('contact.email')} <em>*</em>
                  </span>
                  <input
                    type="email"
                    name="user_email"
                    value={form.user_email}
                    onChange={onChange}
                    required
                    autoComplete="email"
                  />
                </label>
              </div>

              <label className="field">
                <span className="field-label">
                  <FaTag /> {t('contact.subject')}
                </span>
                <input
                  type="text"
                  name="user_subject"
                  value={form.user_subject}
                  onChange={onChange}
                />
              </label>

              <label className="field">
                <span className="field-label">
                  <FaCommentDots /> {t('contact.message')} <em>*</em>
                </span>
                <textarea
                  name="user_message"
                  value={form.user_message}
                  onChange={onChange}
                  rows="6"
                  required
                />
              </label>

              <button
                type="submit"
                className="btn btn-primary contact-submit clickable"
                disabled={status === 'sending'}
              >
                <FaPaperPlane />
                {status === 'sending' ? t('contact.sending') : t('contact.submit')}
              </button>

              {status === 'success' && (
                <div className="form-status form-status--success">
                  <FaCheckCircle /> {t('contact.success')}
                </div>
              )}
              {status === 'error' && (
                <div className="form-status form-status--error">
                  <FaExclamationTriangle /> {t('contact.error')}
                </div>
              )}
            </form>
          </Reveal>

          <Reveal delay={150}>
            <div className="side-card glass">
              <h3>{t('contact.sidebarTitle')}</h3>
              <ul className="side-info">
                <li>
                  <FaMapMarkerAlt />
                  <span>{country}</span>
                </li>
                <li>
                  <FaEnvelope />
                  <a href={`mailto:${profile.email}`} className="clickable">
                    {profile.email}
                  </a>
                </li>
                {/* <li>
                  <FaPhone />
                  <a href={`tel:${profile.phone}`} className="clickable">
                    {profile.phone}
                  </a>
                </li> */}
              </ul>
              <div className="side-social">
                <a
                  href="https://www.linkedin.com/in/murat-s-960b5a230/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="clickable"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://github.com/MuratSelcukoglu"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                  className="clickable"
                >
                  <FaGithub />
                </a>
              </div>
              <div className="side-availability">
                <span className="dot-pulse" />
                {t('contact.available')}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
